import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'

const getWorkflowProcess = async (token, id) => {
  const url = `workflow_processes/${id}`
  const data = await apiGet({ url, token })
  return data
}

export default function useWorkflowProcess({ id, options }) {
  const token = useContext(AuthContext)
  const queryKey = ['workflow-process', id]
  const queryFn = () => getWorkflowProcess(token, id)

  return useQuery(queryKey, queryFn, {
    ...options
  })
}
